import styled from 'styled-components';
import { Text } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH, DESKTOP_EXTRA_SMALL_WIDTH, TABLET_WIDTH } from 'Styles/variables/sizes';
import { pxToRem } from 'Styles/utils/utils';

export const StyledText = styled(Text)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    margin-bottom: ${pxToRem(10)};
  }
`;

export const GradientText = styled(Text)`
  background: ${({ theme: { gradients } }) => gradients.gold_gradient};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${({ isBig }) => (isBig ? pxToRem(45) : pxToRem(27))};
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    margin: 0;
    font-size: ${({ isBig }) => (isBig ? pxToRem(24) : pxToRem(24))};
  }
`;

export const SignUpBox = styled.div`
  background-color: ${({ theme: { colors } }) => colors.blue_1};
  padding: ${pxToRem(36)} ${pxToRem(55)};
  border-radius: 14px;
  width: 100%;
  max-width: ${pxToRem(406)};
  margin: 0 ${pxToRem(30)};
  position: relative;
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    padding: ${pxToRem(24)};
    margin-bottom: ${pxToRem(20)};
    > p:first-child {
      display: none;
    }
  }
  @media screen and (max-width: ${TABLET_WIDTH}) {
    display: none;
  }
`;

export const TermsContainer = styled.div`
  width: 100%;
  max-width: ${pxToRem(600)};
  margin: 0 auto;
  padding: ${pxToRem(10)};

  @media screen and (max-width: ${MOBILE_WIDTH}) {
    max-width: 100%;
  }
`;
